export default __webpack_public_path__ + "static/media/adenike.bc71919d.png";